import { whyChooseItems, stats } from '@/mocks/categories';

export default function WhyChooseUs() {
  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">Why Choose Our Spreadsheet</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Built for Smart Shoppers
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Every feature of our CSSBuy Spreadsheet directory is designed to make your shopping experience safer, faster, and more enjoyable
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-14">
          {whyChooseItems.map((item) => (
            <div key={item.title} className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200 transition-colors">
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-accent-500 rounded-lg p-8 md:p-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {stats.map((stat) => (
              <div key={stat.label}>
                <p className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-1">{stat.value}</p>
                <p className="text-sm text-background-50/80">{stat.label}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}